import {
  type CaseReducer,
  type PayloadAction,
  createSlice,
} from '@reduxjs/toolkit';

interface OrganizationState {
  id: string;
  showtimeDomain: string;
  planId: 'environment' | 'live';
}

const organizationInitialState: OrganizationState = {
  id: '',
  planId: 'environment',
  showtimeDomain: '',
};

export const organizationSlice: ReturnType<
  typeof createSlice<
    OrganizationState,
    {
      setOrganizationId: CaseReducer<
        OrganizationState,
        PayloadAction<OrganizationState['id']>
      >;
      setShowtimeDomain: CaseReducer<OrganizationState, PayloadAction<string>>;
      setOrganizationPlanId: CaseReducer<
        OrganizationState,
        PayloadAction<OrganizationState['planId']>
      >;
    },
    'organization'
  >
> = createSlice({
  name: 'organization',
  initialState: organizationInitialState,
  reducers: {
    setOrganizationId: (state, action) => {
      state.id = action.payload;
    },
    setShowtimeDomain: (state, action) => {
      state.showtimeDomain = action.payload;
    },
    setOrganizationPlanId: (state, action) => {
      state.planId = action.payload;
    },
  },
});

export const { setOrganizationId, setOrganizationPlanId, setShowtimeDomain } =
  organizationSlice.actions;
